import { BANK_STATEMENT_ANALYSER_ACTIONS } from "constants/actions";

export function createRequest(caseId, requestData) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.CREATE_ANALYSER_REQUEST,
        payload: {
            caseId,
            requestData
        }
    };
}

export function createProfiosRequest(caseId, requestData) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.CREATE_ANALYSER_REQUEST_PERFIOS,
        payload: {
            caseId,
            requestData
        }
    };
}

export function createdRequest(caseId, requestData) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.CREATED_ANALYSER_REQUEST,
        payload: {
            caseId,
            requestData
        }
    };
}

export function failedCreateRequest(caseId, requestData, error) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_CREATE_ANALYSER_REQUEST,
        payload: {
            caseId,
            requestData
        },
        error
    };
}

export function fetchJobsList(caseId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_ANALYSER_JOBS,
        payload: {
            caseId
        }
    };
}

export function fetchedJobsList(caseId, data) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_ANALYSER_JOBS,
        payload: {
            caseId,
            data
        }
    };
}

export function failedFetchJobsList(caseId, error) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_ANALYSER_JOBS,
        payload: {
            caseId
        },
        error
    };
}

export function fetchJobsDetails(caseId, jobId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_REQUEST_DETAILS,
        payload: {
            caseId,
            jobId
        }
    };
}

export function fetchJobsDetailsPerfios(caseId, jobId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_REQUEST_DETAILS_PERFIOS,
        payload: {
            caseId,
            jobId
        }
    };
}

export function fetchedJobsDetails(caseId, jobId, data) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_REQUEST_DETAILS,
        payload: {
            caseId,
            jobId,
            data
        }
    };
}

export function failedFetchJobsDetails(caseId, jobId, error) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_REQUEST_DETAILS,
        payload: {
            caseId,
            jobId
        },
        error
    };
}

export function fetchStatementAnalysis(caseId, requestId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_STATEMENT_ANALYSIS,
        payload: {
            caseId,
            requestId
        }
    };
}

export function fetchStatementAnalysisPerfois(caseId, requestId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_STATEMENT_ANALYSIS_PERFIOS,
        payload: {
            caseId,
            requestId
        }
    };
}

export function fetchedStatementAnalysis(caseId, requestId, data) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_STATEMENT_ANALYSIS,
        payload: {
            caseId,
            requestId,
            data
        }
    };
}

export function failedFetchStatementAnalysis(caseId, requestId, error) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_STATEMENT_ANALYSIS,
        payload: {
            caseId,
            requestId
        },
        error
    };
}

export function retryAnalysis(caseId, requestId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS,
        payload: {
            caseId,
            requestId
        }
    };
}

export function retryAnalysisPerfios(caseId, requestId) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS_PERFIOS,
        payload: {
            caseId,
            requestId
        }
    };
}

export function retryAnalysisSucceed(caseId, requestId, data) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS_SUCCESS,
        payload: {
            caseId,
            requestId,
            data
        }
    };
}

export function retryAnalysisFailed(caseId, requestId, error) {
    return {
        type: BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS_SUCCESS,
        payload: {
            caseId,
            requestId
        },
        error
    };
}